// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__22eLJ","header":"MergedInvoice_header__1kvxp"};